import { StContainer } from './Section.styled'

import type { ReactNode } from 'react'

interface Props {
  className?: string
  children?: ReactNode
}

export const Section = ({ children, className }: Props) => {
  return <StContainer className={className}>{children}</StContainer>
}
